import React from 'react';
import { SecondaryButton } from 'sharedComponents/Buttons';
import { Theme, useMediaQuery, useTheme } from '@mui/material';
import { ConnectModals } from 'features/Connect/utils/connectEnums';
import { useConnectContext } from 'features/Connect/features/Context/ConnectContextProvider';

interface ExternalApplicationButtonProps {
  sx?: object;
  size?: 'small' | 'medium' | 'large';
  children?: React.ReactNode;
  vacancyId: string;
}

export const ExternalApplicationButton: React.FC<ExternalApplicationButtonProps> = ({
  sx,
  size = 'small',
  children = 'Link to formal application',
  vacancyId,
}) => {
  const { connectContextActions } = useConnectContext();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleClick = () => {
    if (!vacancyId || vacancyId === '0') {
      console.error('No vacancy ID found for link to formal application');
      return;
    }
    connectContextActions.setModalOpen(ConnectModals.READY_TO_CONNECT_MODAL, true);
  };

  return (
    <SecondaryButton onClick={handleClick} size={size} sx={sx ?? buttonStyles(theme, isMobile)}>
      {children}
    </SecondaryButton>
  );
};

const buttonStyles = (theme: Theme, isMobile: boolean) => ({
  color: theme.palette.text.secondary,
  border: `1px solid ${theme.palette.gray.mediumLight}`,
  borderRadius: theme.shape.borderRadius * 0.5,
  padding: '8px 14px',
  width: isMobile ? '100%' : 'auto',
  fontSize: theme.typography.fontSize,
  fontWeight: theme.typography.fontWeightMediumBold,
  '&:hover': {
    backgroundColor: theme.palette.white.medium,
    border: `1px solid ${theme.palette.text.secondary}`,
  },
  '& .MuiTouchRipple-root': {
    color: theme.palette.gray.mediumLight,
  },
});
